import { render, staticRenderFns } from "./UserGroupUsers.vue?vue&type=template&id=83e60242&scoped=true&"
import script from "./UserGroupUsers.vue?vue&type=script&lang=js&"
export * from "./UserGroupUsers.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupUsers.vue?vue&type=style&index=0&id=83e60242&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e60242",
  null
  
)

export default component.exports